import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { QuickFilter, QuickFilterControl, QuickFilterClear } from '@mui/x-data-grid';
import { InputAdornment, TextField } from '@mui/material';

const StyledQuickFilter = styled(QuickFilter)({
	display: 'grid',
	alignItems: 'center',
	margin: '0 26px',
});

const StyledTextField = styled(TextField)(({ theme }) => ({
	gridArea: '1 / 1',
	overflowX: 'clip',
	width: 240,
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: theme.palette.grey[500],
	},
	'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: theme.palette.grey[600],
	},
}));

export const ToolBarSearch = () => {
	return (
		<StyledQuickFilter>
			<QuickFilterControl
				render={({ ref, ...controlProps }, state) => (
					<StyledTextField
						{...controlProps}
						inputRef={ref}
						aria-label="Search"
						placeholder="Search..."
						size="small"
						slotProps={{
							input: {
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon fontSize="small" />
									</InputAdornment>
								),
								endAdornment: state.value ? (
									<InputAdornment position="end">
										<QuickFilterClear
											edge="end"
											size="small"
											aria-label="Clear search"
											material={{ sx: { marginRight: -0.75 } }}
										>
											<CancelIcon fontSize="small" />
										</QuickFilterClear>
									</InputAdornment>
								) : null,
								...controlProps.slotProps?.input,
							},
							...controlProps.slotProps,
						}}
					/>
				)}
			/>
		</StyledQuickFilter>
	);
};
